import { http } from '../AxiosConfig'
class UploadFilesService {
  upload(file, userId, reimbursementItem, onUploadProgress) {
    const formData = new FormData()
    formData.append('receipt[files]', file)
    formData.append('receipt[user_id]', userId)
    formData.append('receipt[reimbursement_item_id]', reimbursementItem)
    return http.post(
      '/receipts',
      formData,
      {
        headers: {
          Accept: `application/json`,
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
      },
    )
  }
  getFiles(reimbursementId) {
    return http.get('/receipts', { reimbursement_id: reimbursementId })
  }
}
export default new UploadFilesService()
